export default [
    {
        path: "/registration/account",
        name: "Account",
        meta: { title: "Account", authRequired: true },
        component: () => import("../views/workflow/processes.vue"),
    },
    {
        path: "/registration/settings",
        name: "Settings",
        meta: { title: "Settings", authRequired: true },
        component: () => import("../views/registration/register.vue"),
    },
    {
        path: "/registration/procuring-entities",
        name: "procuring-entities",
        meta: { title: "procuring-entities", authRequired: true },
        component: () => import("../views/registration/procuring-entities.vue"),
    },
    {
        path: "/registration/suppliers",
        name: "suppliers",
        meta: { title: "suppliers", authRequired: true },
        component: () => import("../views/registration/suppliers.vue"),
    },
    {
        path: "/registration/supplier-profile",
        name: "supplier-profile",
        meta: { title: "supplier-profile", authRequired: true },
        component: () => import("../views/registration/supplier-profile.vue"),
    },
    {
        path: "/registration/create-procuring-entity",
        name: "create-procuring-entity",
        meta: { title: "create-procuring-entity", authRequired: true },
        component: () => import("../views/registration/create-procuring-entity.vue"),
    },
    {
        path: "/registration/update-procuring-entity",
        name: "update-procuring-entity",
        meta: { title: "update-procuring-entity", authRequired: true },
        component: () => import("../views/registration/update-procuring-entity.vue"),
    },
    {
        path: "/registration/file-based-integrations",
        name: "file-based-integrations",
        meta: { title: "file-based-integrations", authRequired: true },
        component: () => import("../views/registration/file-based-integrations.vue"),
    },
]
